import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { SectionCTA } from './SectionCTA';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-brand-50 px-5 py-16 md:py-24" data-id="element-320" data-mp="3fy2zlwtj1u41">
      <div className="mx-auto max-w-6xl" data-id="element-321" data-mp="3b1487m19019j">
        <SectionHeading eyebrow="What Therapists Gain From a More Structured Planning Process" title="Clearer Priorities. More Organized Treatment Plans. Better-Defined Functional Goals." data-id="element-322" data-mp="3b0aw05jisjk0" />

        <ul className="mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-323" data-mp="32290g5ik2j44">
          {testimonials.map(t => <li key={t.name} className="flex flex-col rounded-3xl bg-white p-6 shadow-sm ring-1 ring-brand-100" data-id="element-324" data-mp="2s1q9yrwhk4d8">
              <span className="self-start rounded-full bg-brand-100 px-3 py-1 text-xs font-extrabold uppercase tracking-wide text-brand-700" data-id="element-325" data-mp="v96nm9onwdo7">
                {t.topic}
              </span>
              <QuoteIcon className="mt-5 h-8 w-8 text-brand-300" aria-hidden="true" data-id="element-326" data-mp="h5yamk89jn69" />
              <blockquote className="mt-2 text-lg leading-relaxed text-brand-950" data-id="element-327" data-mp="h8ay1cwsipqp">“{t.quote}”</blockquote>
              <div className="mt-auto flex items-center gap-4 pt-6" data-id="element-328" data-mp="77s7jzaq0azt">
                <img src={t.photo} alt={t.name} className="h-16 w-16 shrink-0 rounded-full object-cover ring-4 ring-brand-100" loading="lazy" data-id="element-329" data-mp="79ldfcdier6r" />
                <div data-id="element-330" data-mp="14vj0zo6qxmpk">
                  <p className="text-base font-extrabold text-brand-950" data-id="element-331" data-mp="14vsj6pljupkp">{t.name}</p>
                  <p className="text-sm text-brand-900/65" data-id="element-332" data-mp="q6waqrfkzajk">{t.role}</p>
                </div>
              </div>
            </li>)}
        </ul>

        <SectionCTA label="I Want a More Structured Intervention System" data-id="element-333" data-mp="v3wjxb7q8tew" />
      </div>
    </section>;
}